/* site-audit 2026-10-07: shared helpers for Formula Finder, Pairs Well and the Compare/Calculator page. */
(function(){
  if (window.IBTools) return;
  var data = null;
  function products(){
    if (data) return data;
    try { data = JSON.parse(document.getElementById('ib-products-data').textContent); } catch(e) { data = {}; }
    return data;
  }
  function money(cents){
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, (window.themeCurrency && themeCurrency.money_format) || '${{amount}}');
    } catch(e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function firstAvail(p){
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0] || null;
  }
  /* items: [{handle, variantId?, subscribe?}] -> /cart/add.js, then open the theme cart drawer */
  function add(items, btn, statusEl){
    var ps = products(), payload = [];
    items.forEach(function(it){
      var p = ps[it.handle]; if (!p) return;
      var v = it.variantId ? p.variants.filter(function(x){ return String(x.id) === String(it.variantId); })[0] : firstAvail(p);
      if (!v) return;
      var line = { id: v.id, quantity: it.quantity || 1 };
      if (it.properties) { var pr = {}, any = false; for (var k in it.properties) if (it.properties[k]) { pr[k] = String(it.properties[k]).slice(0, 30); any = true; } if (any) line.properties = pr; } /* horse profiles: e.g. {_Horse: 'Bella'} */
      if (it.subscribe) {
        var plan = (it.planMonths && p.plans && p.plans[String(it.planMonths)]) || p.plan;
        if (plan) line.selling_plan = plan;
      }
      payload.push(line);
    });
    if (!payload.length) return Promise.resolve();
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    if (statusEl) statusEl.textContent = '';
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: payload })
    }).then(function(r){
      return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
    }).then(function(){
      if (btn) { btn.textContent = 'Added ✓'; }
      if (statusEl) statusEl.textContent = 'Added to your cart.';
      try { document.dispatchEvent(new CustomEvent('cart:refresh:opend')); } catch(e) {}
      setTimeout(function(){ if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); } }, 2200);
    }).catch(function(err){
      if (btn) { btn.innerHTML = label; btn.disabled = false; btn.removeAttribute('aria-busy'); }
      if (statusEl) statusEl.textContent = err.message || 'Could not add to cart. Please try again.';
    });
  }
  window.IBTools = { products: products, money: money, add: add, firstAvail: firstAvail };
})();
